<template>
  <div>
    <div v-show="!isLoading('panel')" class="bar side-by-side" :style="'min-height:' + height + 'px; background-color:' + backgroundColor
      " :class="{
        top: position == 'top',
        footer: position == 'footer',
        none: position == 'none',
      }">
      <div class="size">
        <div :class="{ 'side-by-side': showButtonClose }">
          <slot></slot>
        </div>
        <div :class="{ 'side-by-side': showButtonClose }" class="close-icon" v-if="position == 'top' && showButtonClose"
          @click="close">
          <i class="fa-regular fa-xmark"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "FixedBar",
  props: {
    showButtonClose: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: "top",
    },
    height: {
      type: Number,
      default: 70,
    },
    backgroundColor: {
      type: String,
      default: "white",
    },
  },
  computed: {
    ...mapGetters("generic", ["isLoading"]),
  },
  methods: {
    ...mapMutations("generic", ["addEvent"]),
    close() {
      this.addEvent({ name: "closedFixedBar" });
    },
  },
};
</script>

<style scoped>
.bar {
  position: fixed;
  width: 100%;
  z-index: 20;
  padding: 18px;
  padding-left: 100px;
}

.size {
  max-width: 1600px;
  margin: auto;
}

.none {
  left: 0;
  right: 0;
}

.top {
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 0px solid #e1e1e2;
  box-shadow: 0px 10px 20px -6px rgb(0 0 0 / 5%);
  border-bottom: 0px solid #eff0f1;
}

.footer {
  left: 0;
  bottom: 0px;
  border-top: 0px solid #e1e1e2;
  box-shadow: 0px 10px 20px -6px rgb(0 0 0 / 5%);
  border-top: 0px solid #eff0f1;
}

.close-icon {
  float: right;
  font-size: 30px;
  font-weight: 400;
  line-height: 1;
  color: #b9babb;
  text-shadow: 0 1px 0 #fff;
  padding-right: 80px;
  cursor: pointer;
}
</style>
